import { ToastManager } from './toast-manager.js';

export default function initSettingsMenu(el) {
  const views = el.querySelectorAll('[data-view]');
  const navBtns = el.querySelectorAll('[data-action="nav"]');
  const backBtns = el.querySelectorAll('[data-action="back"]');
  const asyncForms = el.querySelectorAll('form[data-action="async-weight-unit"]');
  const toastManager = new ToastManager();

  function showView(targetViewId) {
    views.forEach(v => {
      if (v.getAttribute('data-view') === targetViewId) {
        v.classList.remove('hidden');
      } else {
        v.classList.add('hidden');
      }
    });
  }

  navBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = btn.getAttribute('data-target');
      showView(target);
    });
  });

  backBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      showView('main');
    });
  });

  asyncForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      try {
        const response = await fetch(form.action, {
          method: form.method,
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data)
        });

        const result = await response.json();

        if (response.ok) {
          // Success State causes a page reload
          window.location.reload();
        } else {
          toastManager.show(result.error || 'No pudimos actualizar la unidad. Por favor, revisa tu conexión.', 'error');
        }
      } catch (error) {
        console.error('Error changing user weight unit:', error);
        toastManager.show('No pudimos actualizar la unidad. Por favor, revisa tu conexión.', 'error');
      } finally {
        if (submitBtn && submitBtn.stopLoading) {
          submitBtn.stopLoading();
        }
      }
    });
  });

  // Automatically reset the internal menu to the 'main' layout when the dropdown fully closes
  document.addEventListener('close-all-menus', () => {
    // Timeout gives the dropdown closure animation time to execute so UI doesnt snap visibly
    setTimeout(() => { showView('main'); }, 200);
  });
}
